// Angular
import { Injectable } from '@angular/core';

import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

// Afidium
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import { IPostTicketsSearchRequest, IPostTicketsSearchResponse, IPostTicketsSearchBody } from './interfaces/IPostTicketsSearch';

@Injectable()
export class TicketResourceService {
    constructor(
        private readonly apiResource: ApiResourceService,
    ) { }

    public getTickets({ whenIssued, ...searchParameters }: IPostTicketsSearchRequest): Observable<IPostTicketsSearchResponse[]> {
        return this.apiResource.post<IPostTicketsSearchBody, IPostTicketsSearchResponse>(
            this.apiResource.getApiUrl('air', 'tickets', 'search'),
            {
                whenIssued: {
                    min: whenIssued.max,
                    max: whenIssued.max,
                }
            },
            searchParameters
        )
            .pipe(
                catchError((error: Error): Observable<IPostTicketsSearchResponse[]> => {
                    if (error.message && error.message.includes("NO ITEMS FOUND FOR DATE REQUESTED")) {
                        return of([]);
                    }

                    return throwError(error);
                })
            );
    }
}
